import { useQuery, useQueryClient } from "@tanstack/react-query";
import { PurchaseOrderService } from "src/services";
import { QueryParamsMapper } from "src/mappers/queryParamsMapper";
import { queryKeys } from "src/constants";
import { DateTimeRange, PurchaseOrderPaginationOptions, PurchaseOrdersFilters } from "src/types";

const usePurchaseOrders = (
  purchaseOrderService: PurchaseOrderService,
  dateTimeRange?: DateTimeRange,
  filter?: PurchaseOrdersFilters,
  paginationOptions?: PurchaseOrderPaginationOptions,
  deliveryDateTimeRange?: DateTimeRange,
  receiptDateTimeRange?: DateTimeRange
) => {
  const queryClient = useQueryClient();

  const queryParams = QueryParamsMapper.getPurchaseOrdersQueryParams(
    dateTimeRange,
    filter,
    paginationOptions,
    deliveryDateTimeRange,
    receiptDateTimeRange
  );

  const {
    data: paginatedPurchaseOrders,
    error: fetchError,
    isLoading
  } = useQuery({
    queryKey: queryKeys.paginatedPurchaseOrders(queryParams),
    queryFn: () => purchaseOrderService.getPurchaseOrders(queryParams)
  });

  const refreshPurchaseOrders = () => {
    queryClient.removeQueries({
      queryKey: queryKeys.paginatedPurchaseOrders(),
      exact: false
    });
  };

  return { paginatedPurchaseOrders: paginatedPurchaseOrders, fetchError, isLoading, refreshPurchaseOrders };
};

export { usePurchaseOrders };
